import { libraryData } from '../../../mocks/library';

export default function Library() {
  return (
    <section id="library" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="flex justify-center items-center space-x-2 mb-4">
            <i className="ri-vip-diamond-line text-2xl text-amber-500"></i>
            <span className="text-amber-600 text-sm font-semibold uppercase tracking-wider">
              Premium Library
            </span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900">심층 비즈니스 인사이트</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
          {libraryData.slice(0, 3).map((item, index) => (
            <div
              key={item.id}
              className={`rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer ${
                index === 2 ? 'relative' : 'bg-gradient-to-br from-gray-50 to-gray-100'
              }`}
              style={
                index === 2
                  ? {
                      backgroundImage: `url('${item.image}')`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      minHeight: '400px',
                    }
                  : {}
              }
            >
              {index === 2 ? (
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent flex flex-col justify-end p-8">
                  <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm text-white text-xs font-medium rounded-full mb-3 w-fit">
                    {item.category}
                  </span>
                  <h3 className="text-2xl font-bold text-white">{item.title}</h3>
                </div>
              ) : (
                <div className="p-8">
                  <div className="flex items-start space-x-4 mb-6">
                    <div className="w-12 h-12 rounded-full bg-teal-500 flex-shrink-0"></div>
                    <div>
                      <p className="font-bold text-gray-900">{item.author}</p>
                      <p className="text-sm text-gray-600">{item.role}</p>
                    </div>
                  </div>
                  <div className="mb-6">
                    <i className="ri-double-quotes-l text-4xl text-teal-500"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                  <p className="text-gray-600 text-sm mb-4">{item.description}</p>
                  {item.isPremium && (
                    <span className="inline-block px-3 py-1 bg-amber-100 text-amber-700 text-xs font-medium rounded-full">
                      Premium
                    </span>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div
            className="lg:col-span-2 rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer relative"
            style={{
              backgroundImage: `url('${libraryData[3].image}')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              minHeight: '350px',
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 via-gray-900/50 to-transparent flex flex-col justify-end p-8">
              <span className="inline-block px-3 py-1 bg-teal-500 text-white text-xs font-medium rounded-full mb-3 w-fit">
                Featured
              </span>
              <p className="text-white text-sm mb-2">{libraryData[3].author}</p>
              <p className="text-white/80 text-xs mb-4">{libraryData[3].role}</p>
              <h3 className="text-3xl font-bold text-white">{libraryData[3].title}</h3>
            </div>
          </div>

          <div className="space-y-6">
            {libraryData.slice(4, 6).map((item) => (
              <div
                key={item.id}
                className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="mb-4">
                  <i className="ri-double-quotes-l text-3xl text-teal-500"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">{item.title}</h3>
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 rounded-full bg-teal-500 flex-shrink-0"></div>
                  <div>
                    <p className="font-medium text-gray-900 text-sm">{item.author}</p>
                    <p className="text-xs text-gray-600">{item.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
